(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["product-recommendations"]) return;
  try {
    
  const productRecommendations = document.querySelector('.product-recommendations');
  if (productRecommendations) {
    const observer = new IntersectionObserver((entries, observer) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          observer.unobserve(productRecommendations);
          const url = productRecommendations.dataset.url;
          fetch(url)
            .then(response => response.text())
            .then(text => {
              const html = document.createElement('div');
              html.innerHTML = text;
              const recommendations = html.querySelector('.product-recommendations');
              if (recommendations && recommendations.innerHTML.trim().length) {
                productRecommendations.innerHTML = recommendations.innerHTML;
              }
            })
            .catch(e => console.error(e));
        }
      });
    }, { rootMargin: '0px 0px 400px 0px' });
    observer.observe(productRecommendations);
  }

  } catch(e) { console.error(e); }
})();
})();
